import React from "react";
import { useNavigate } from "react-router-dom";
import TrustedCompanies from "./ReuasbleComponets/TrustedCompanies";
import CTAButtons from "./ReuasbleComponets/CTAButtons";
import { Link } from "react-router-dom";
import AsSeenOn from "./ReuasbleComponets/AsSeenOn";
import Cards from "./AboutUsScroller";
const AboutUs = () => {
  const navigate = useNavigate();
  const gallery = [
    "./../assets/images/new_about_us/gallery/gallery_1.webp",
    "./../assets/images/new_about_us/gallery/gallery_2.webp",
    "./../assets/images/new_about_us/gallery/gallery_3.webp",
    "./../assets/images/new_about_us/gallery/gallery_4.webp",
    "./../assets/images/new_about_us/gallery/gallery_5.webp",
    "./../assets/images/new_about_us/gallery/gallery_6.webp",
  ];
  const testimonials = [
    {
      initials: "CS",
      name: "Charles S",
      title: "HAPPY CLIENT – REMARKABLE WORK",
      review:
        "Nxatel - Their service and installation was excellent and the phone system up and running with excellent service. I thank them for their good service.",
      rating: 5,
      source: "./../assets/images/new_about_us/hellopeter_review.webp",
      link: "https://www.hellopeter.com/nxatel/reviews/happy-client-remarkable-work-5092537#",
    },
    {
      initials: "P",
      name: "Pamela Annandale",
      role: "Local Guide",
      review:
        "Service excellent. Whenever we encounter problems, Nxatel are on it immediately. Call back to ensure that we are up and running. Ellis Singer Verspreiders (Pty) Ltd are happy clients of Nxatel.",
      rating: 5,
      source: "./../assets/images/new_about_us/google_review.webp",
      link: "https://g.co/kgs/d3LVBtS",
    },
    {
      initials: "MH",
      name: "md H",
      role: "East End General Dealer",
      review:
        "Nxatel has given me the best service so far we started out rocky but we ended up getting it right am happy with the service.",
      rating: 5,
      source: "./../assets/images/new_about_us/hellopeter_review.webp",
      link: "https://www.hellopeter.com/nxatel/reviews/east-end-general-dealer-5100603",
    },
  ];
  return (
    <>
      <section className="aboutUs">
        {/* Hero Section */}
        <section className="hero">
          <div className="hero-content">
            <h1>
              Empowering <span className="highlight">Businesses</span> with
              Seamless <span className="highlight">Communication</span>
            </h1>
            <p>
              Stop missing important calls and messages. Get seamless, reliable
              business communication in one simple platform.
            </p>

            <a
              href="https://careers.nxa.tel/jobs/Careers"
              className="btn bg--orange text--white border--2 border--orange sf--t-medium radius--16-0"
            >
              Join Our Team
            </a>
          </div>

          <div className="hero-image">
            <img
              className="laptop"
              src="./../assets/images/new_about_us/hero.webp"
              alt="Video Call"
              loading="lazy"
            />
          </div>
        </section>
        {/* Trusted Companies */}
        <TrustedCompanies />

        <div className="backgroundwhite">
          {/*NxaTel Values Horizontal scroll  */}
          <section className="nxatel_values">
            <h1>
              <span className="nxatel_values__underline">The values</span> that
              drive everything we do
            </h1>
            <Cards />
          </section>

          {/* Our Vision and Mision Section */}
          <section className="vision_mission">
            <div className="vision_mission__content">
              <h1>
                Our <span className="underline">Mission & Vision</span>
              </h1>
              <h2>Our Vision</h2>
              <p>
                To become the leading unified communication platform in Africa,
                empowering businesses with seamless, reliable, and innovative
                solutions that drive growth and efficiency.
              </p>
              <h2>Our Mission</h2>
              <p>
                To simplify and enhance business communication by providing a
                powerful, all-in-one cloud platform that enables SMEs to manage
                calls, meetings, messages, and documents effortlessly—anytime,
                anywhere.
              </p>
            </div>
            <div className="vision_mission__image">
              <img
                className="office"
                src="./../assets/images/new_about_us/nxateloffice.webp"
                alt="NxaTel Reception"
                loading="lazy"
              />
            </div>
          </section>
          {/* Our Story Section */}
          <section className="our_story">
            <div className="our_story__content">
              <h1>Our Story</h1>
              <p>
                Founded with a vision to simplify business communication, NxaTel
                provides an all-in-one Unified Communications as a Service
                (UCaaS) platform. In just three minutes, businesses can set up a
                cloud phone system, conduct virtual meetings, send SMS messages,
                utilise WhatsApp Business, and store documents securely in the
                cloud—all in one app. Whether you're a startup, a growing SME,
                or an established enterprise, we provide the flexibility,
                reliability, and scalability to meet your needs.
              </p>
            </div>
            <div className="our_story__gallery">
              <div className="gallery">
                {gallery.map((src, index) => (
                  <img key={index} src={src} alt={`Gallery ${index + 1}`} />
                ))}
              </div>
            </div>
            <div className="our_story__button">
              <a
                href="https://careers.nxa.tel/jobs/Careers"
                className="btn bg--transparent text--orange border--2 border--orange sf--t-medium radius--16-0"
              >
                Join Our Team
              </a>
            </div>
          </section>
        </div>

        {/* NxaTel Team */}
        <section className="nxatel_team">
          <h1>Our Nxatel Team</h1>
          <div className="nxatel_team__image">
            <img
              className="members"
              src="./../assets/images/new_about_us/newteam.webp"
              alt="NxaTel Team Members"
              loading="lazy"
            />
          </div>
          <div className="nxatel_team__button">
            <a
              href="https://careers.nxa.tel/jobs/Careers"
              className="btn bg--transparent text--orange border--2 border--orange sf--t-medium radius--16-0"
            >
              Join Our Team
            </a>
          </div>
        </section>
        {/* As Featured Section */}
        <section className="as_seen_on__section ">
          <h1>
            As <span>featured in</span>
          </h1>
          <AsSeenOn />
        </section>

        {/* Customer Testimonial section */}
        <section className="testimonial">
          <h1 className="testimonials__heading">
            Testimonials from our satisfied{" "}
            <span className="testimonials__underline">customers</span>
          </h1>
          <div className="testimonials_container ">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="testimonial-card">
                {/* User Info */}
                <div className="testimonial-card__header">
                  <div className="testimonial-card__avatar">
                    {testimonial.initials}
                  </div>
                  <div>
                    <h3 className="testimonial-card__name">
                      {testimonial.name}
                    </h3>
                    {testimonial.role && (
                      <p className="testimonial-card__role">
                        {testimonial.role}
                      </p>
                    )}
                  </div>
                </div>

                {/* Review Content */}
                <div className="testimonial-card__content">
                  <h4 className="testimonial-card__title">
                    {testimonial.title}
                  </h4>
                  <p className="testimonial-card__text">{testimonial.review}</p>
                </div>

                {/* Rating & Source */}
                <div className="testimonial-card__footer">
                  <div className="testimonial-card__stars">⭐️⭐️⭐️⭐️⭐️</div>
                  <a href={testimonial.link}>
                    {" "}
                    <p className="testimonial-card__source">
                      {testimonial.rating}.0 Review from{" "}
                      <img src={testimonial.source} />
                    </p>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Start Free Section*/}
        <section className="startfree">
          <div className="startfree__content">
            <h1>Start Your Free Trial – No Credit Card Needed</h1>
            <p>
              Plans start at R159 per user/per month No long-term contracts. No
              hidden fees. No nonsense.
            </p>
            <div className="about-button">
              <CTAButtons />
            </div>
          </div>
          <div className="startfree__image">
            <img
              className="devices_app"
              src="./../assets/images/new_about_us/phonelaptop.webp"
              alt="Phone and Laptop Showcasing App"
              loading="lazy"
            />
          </div>
        </section>
      </section>
    </>
  );
};

export default AboutUs;
